export const LENS_TREASURY = {
  Mainnet: "0x3413b49e2a4cd83a20d9941764f3c4b983983b80",
  Staging: "0x0000000000000000000000000000000000000000",
  Testnet: "0x7d5A4032104c0A3690eB3f41776AFb0d5Cc6f960"
} as const;   